import React from 'react';
import './styles.css';

const OrderInfoSection = ({
  title = "What happens next?",
  items = [
    {
      id: "transfers",
      title: "Number transfers",
      description:
        "If your order includes number transfers, We’ll be in touch to collect the details needed and coordinate the port-in from your current telco.",
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 18L7 23L12 28"
            stroke="#0088FF"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 23H25C29.4183 23 33 19.4183 33 15C33 13.5 32.5 12 31.5 11"
            stroke="#7DD3FC"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <path
            d="M28 22L33 17L28 12"
            stroke="#0088FF"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33 17H15C10.5817 17 7 20.5817 7 25C7 26.5 7.5 28 8.5 29"
            stroke="#7DD3FC"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      )
    },
    {
      id: "delivery",
      title: "FREE Physical SIM delivery",
      description:
        "If your order includes physical SIMs, we’ll contact you to arrange the delivery date and time.",
      icon: (
        <svg width="44" height="32" viewBox="0 0 44 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0" y="4" width="28" height="20" rx="6" fill="#93C5FD" />
          <path
            d="M28 10H36C38.2091 10 40 11.7909 40 14V21C40 22.6569 38.6569 24 37 24H28V10Z"
            fill="#93C5FD"
          />
          <rect x="31" y="13" width="5" height="5" rx="1.5" fill="#0088FF" />
          <circle cx="10" cy="24" r="4" fill="#0088FF" />
          <circle cx="32" cy="24" r="4" fill="#0088FF" />
        </svg>
      )
    }
  ]
}) => {
  return (
    <div className="what-happens-next-card">
      {/* Header Bar */}
      <div className="what-happens-next-header">
        <h3 className="what-happens-next-title">{title}</h3>
      </div>

      {/* Body Content */}
      <div className="what-happens-next-body">
        {items.map((item, index) => (
          <React.Fragment key={item.id || index}>
            <div className="next-step-item">
              <div className="next-step-icon">{item.icon}</div>
              <div className="next-step-content">
                <h4 className="next-step-title">{item.title}</h4>
                <p className="next-step-desc">{item.description}</p>
              </div>
            </div>
            {index < items.length - 1 && <hr className="next-step-divider" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default OrderInfoSection;